/**
 * ReportContainer Component
 *
 * Print-friendly wrapper for report content.
 * Provides consistent styling and print header for all reports.
 */

import React from 'react';
import { cn } from '@/lib/utils';

interface ReportContainerProps {
  children: React.ReactNode;
  title: string;
  projectName: string;
  clientName?: string;
  generatedDate?: Date;
  floorPlanFilter?: string;
  className?: string;
}

export function ReportContainer({
  children,
  title,
  projectName,
  clientName,
  generatedDate = new Date(),
  floorPlanFilter = 'All Floor Plans',
  className,
}: ReportContainerProps) {
  return (
    <div className={cn('report-container', className)}>
      {/* Print header - hidden on screen, visible when printing */}
      <div className="report-print-header hidden print:block mb-6 pb-4 border-b-2 border-primary">
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-2xl font-bold text-foreground">{title}</h1>
            <p className="text-lg text-muted-foreground mt-1">{projectName}</p>
          </div>
          <div className="text-right text-sm text-muted-foreground">
            <p>Generated: {generatedDate.toLocaleDateString()}</p>
            {clientName && <p>Client: {clientName}</p>}
            <p>Floor Plan: {floorPlanFilter}</p>
          </div>
        </div>
      </div>

      {/* Report content */}
      <div className="report-content">
        {children}
      </div>
    </div>
  );
}
